<template>
	<div>
        <div class="deskPad" :id="contentData.text.replace(/ /g,'')" v-if="!authenticated">
            <h2>{{contentData.text}}</h2>
        </div>
        <div v-else>
            <div class="form-group">
                <label>Heading</label>
                <input type="text" class="form-control" v-model="contentData.text" />
            </div>
        </div>
	</div>
</template>

<script>
import $ from 'jquery';

	export default {
		name: 'headingcontent-component',
		props: ['contentData', 'index', 'hide', 'dragging', 'authenticated'],
		methods: {
			toggleHide() {
				this.$emit('toggle-hide');
			},
			deleteSection() {
				this.$emit('delete')
				this.pod.sections.splice(index, 1);
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @media only screen and (min-width: 992px) {
        .deskPad {
            margin-left: 100px;
            margin-right: 100px;
        }
    }
</style>
